<template>
  <div>
    <Modal width="860" v-model="isShow" :mask-closable="false"
           @on-ok="ok" :loading="loading" @on-cancel="cancel"
           class="mask long-modal"
    >
      <h3 slot="header" class="modal-header">解约录入交割 <span>{{projectName}}</span><span class="dot">.</span><span>{{stockNumber}}</span></h3>
      <div class="specialdrop " style="padding: 0 10px;">
        <div>
          <h4>生活费用信息</h4>
          <div>
            <Row class="row">
              <Col span="2">项目类别</Col>
              <Col span="2">是否智能</Col>
              <Col span="3">付费模式</Col>
              <Col span="3">上次示数</Col>
              <Col span="3">本次示数</Col>
              <Col span="2">单价</Col>
              <Col span="3">应退费用</Col>
              <Col span="3">附件</Col>
              <Col span="3">修改附件</Col>
            </Row>
            <Row class="row notip" v-for="(item,index) in data1Copy" :key="'keyN'+index">
              <Form :model="item" :inline="true" :rules="item.meterPayType===0?formRules12:formRules1" :ref="'form1'+index">
                <Col span="2">{{item.meterTypeName ||'-' }}</Col>
                <Col span="2">{{item.isSmartDevice===true?'是':'否'}}</Col>
                <Col span="3">
                  <!--//付费模式  欢乐谷支持修改-->
                  <div v-if="item.allowModify">
                    <FormItem prop="meterPayType" class="notip" style="display: block">
                      <Select v-model="item.meterPayType" >
                        <Option v-for="(item,index) in payTypeList" :value="item.value" :key="'keyM'+index">
                          {{item.text}}
                        </Option>
                      </Select>
                    </FormItem>
                  </div>
                  <div v-else>{{item.meterPayType===0?'预付费':(item.meterPayType===1?'后付费':'-')}}</div>
                </Col>

                <Col span="3">
                  <!--上次示数-->
                  <div v-if="item.preMeterEdit===1">
                      <span>{{ item.preMeterDisplay?item.preMeterDisplay:(item.preMeterDisplay===0?0:'-')}}</span>
                  </div>
                  <div v-else>
                  <FormItem prop="preMeterDisplay" class="notip">
                    <InputNumber class="inputwidth" v-model="item.preMeterDisplay" @on-change="getMeterAmount(item)"/>
                  </FormItem>
                  </div>
                </Col>

                <Col span="3">
                  <!--本次示数-->
                <div v-if="item.curMeterEdit===1">
                    <span>{{ item.curMeterDisplay?item.curMeterDisplay:(item.curMeterDisplay===0?0:'-')}}</span>
                </div>
                <div v-else>
                  <FormItem prop="curMeterDisplay" class="notip">
                    <InputNumber class="inputwidth" v-model="item.curMeterDisplay" @on-change="getMeterAmount(item)"/>
                  </FormItem>
                </div>
                </Col>
                <Col span="2">{{item.unitPrice || 0}}</Col>
                <Col span="3">
                  <!--应退费用-->
                  <FormItem prop="meterAmount" class="notip">
                    <Input class="inputwidth" v-model="item.meterAmount" disabled/>
                  </FormItem>
                </Col>
                <Col span="3">
                <!--附件-->
                <a v-if="item.meterPic" href="javascript:;" @click.stop="showImg(item.meterPic)">{{item.meterPicName}}</a>
                <span v-else>无</span>
                </Col>
                <Col span="3">
                <!--修改附件-->
                <div v-if="item.curMeterEdit===1">不支持修改</div>
                <div v-else>
                  <Upload style="display: inline-block;margin-left: 5px"
                          :action="baseUrl+'/file/uploadFile'"
                          :data="{type:index}"
                          :on-success="handleSuccess"
                          :headers="{'Access-Token':token}"
                          :show-upload-list="false"
                          :on-error="handleError"
                          :format="['jpg','jpeg','png']"
                          :on-format-error="formatError"
                  >
                    <a v-if="item.meterPic" href="javascript:;">修改</a>
                    <a v-if="!item.meterPic" href="javascript:;">上传(必传)</a>
                  </Upload>
                </div>
                </Col>
              </Form>
            </Row>
          </div>
        </div>
        <div class="mt36">
          <div class=" ">
            <h4 style="display: inline-block">房间物品信息</h4>
            <span style="color: red;float: right">物品信息如有缺误，请移步资产管理添加。</span>
          </div>
          <div class="">
            <Row class="row">
              <Col span="4">物品</Col>
              <Col span="4">大类</Col>
              <Col span="4">数量</Col>
              <Col span="4">价格</Col>
              <Col span="4">状态</Col>
              <Col span="4">赔付费用</Col>
            </Row>
            <Row class="row" v-for="(item,index) in data2" :key="'keyX'+index">
              <Form :model="item" :inline="true" :rules="formRules2" :ref="'form2'+index">
                <Col span="4">{{item.goodsName || '-'}}</Col>
                <Col span="4">{{item.goodsType ||'-' }}</Col>
                <Col span="4">{{item.goodsCount?item.goodsCount:(item.goodsCount===0?0:'-') }}</Col>
                <Col span="4">{{item.goodsPrice?item.goodsPrice:(item.goodsPrice===0?0:'-')}}</Col>
                <Col span="4">{{item.goodsStatusName || '-'}}</Col>
                <Col span="4">
                  <FormItem class="notip" prop="goodsPayAmount">
                    <Input class="inputwidth" v-model="item.goodsPayAmount"/>
                  </FormItem>
                </Col>
              </Form>
            </Row>
          </div>
        </div>
        <!--<Table :columns="columns2" :data="data2" class="mb26"></Table>-->
        <div class="mt36" style="margin-bottom: 50px">
          <h4>房间装修信息</h4>
          <div>
            <Row class="row">
              <Col span="5">装修项目</Col>
              <Col span="4">新旧</Col>
              <Col span="4">面积</Col>
              <Col span="4">状态</Col>
              <Col span="4">赔付费用</Col>
            </Row>
            <Row class="row" v-for="(item,index) in data3" :key="'keyW'+index">
              <Form :model="item" :inline="true" :rules="formRules3" :ref="'form3'+index">
                <Col span="5">{{item.goodsName}}</Col>
                <Col span="4">
                  <!--新旧-->
                  <FormItem class="notip" prop="goodsNewOld">
                    <Select class="inputwidth" v-model="item.goodsNewOld">
                      <!--<Option></Option>-->
                      <Option v-for="(item,index) in list3" :value="item.value"
                              :key="'keyY'+index">{{item.text}}
                      </Option>
                    </Select>
                  </FormItem>
                </Col>
                <Col span="4">
                  <!--面积-->
                  <FormItem class="notip" prop="unit">
                    <Input class="inputwidth" v-model="item.unit"/>
                  </FormItem>
                </Col>
                <Col span="4">
                  <!--状态-->
                  <FormItem class="notip" prop="goodsStatus">
                    <Select class="inputwidth" v-model="item.goodsStatus">
                      <!--<Option></Option>-->
                      <Option v-for="(item,index) in list4" :value="item.value"
                              :key="'keyF'+index">{{item.text}}
                      </Option>
                    </Select>
                  </FormItem>
                </Col>
                <Col span="4">
                  <!--赔付费用-->
                  <FormItem class="notip" prop="goodsPayAmount">
                    <Input class="inputwidth" v-model="item.goodsPayAmount"/>
                  </FormItem>
                </Col>
              </Form>
            </Row>
          </div>
        </div>
      </div>
      <img-show :n="imgN" :src="imgSrc"></img-show>
    </Modal>
  </div>
</template>
<script>
  import {
    getPersonalSurrenderInitInfo,
    getPersonalSurrenderMeterDeliveryInitInfo,
    getSurrenderDecorationGoodsDeliveryInitInfo,
    getSurrenderGoodsDeliveryInitInfo,
    validChangeRentContract,
    surrenderdeliverysave,
  } from "../../../../../api/contractList";
  import {deepClone} from "../../../../../utils/format";
  import {getBaseUrl} from "../../../../../utils/public";
  import {getToken} from "../../../../../utils/auth";
  import {formatDateTime} from "../../../../../utils/format";
  import ImgShow from 'components/ImgShow/index'
  import {calSurrenderMeterDeliveryAmount} from "../../../../../api/contractList";

  export default {
    // name: "",
    components: {
      ImgShow

    },
    props: {
      stockNumber: {
        type: String,
        default: ''
      },
      projectName: {
        type: String,
        default: ''
      },
      surrenderFid: {
        type: String,
        default: ""
      },
      n: {
        type: Number,
        default: 0
      },
      contractFid: {
        type: String,
        default: ""
      },
      stockFid: {
        type: String,
        default: ""
      },
    },
    watch: {
      n() {
        this.cleanData()
        // this.getPersonalSurrenderInitInfo()
        this.getPersonalSurrenderMeterDeliveryInitInfo()
        this.getSurrenderDecorationGoodsDeliveryInitInfo()
        this.getSurrenderGoodsDeliveryInitInfo()
        this.isShow = true
      }
    },
    data() {
      return {
        imgSrc: '',
        imgN: 0,
        data: null,
        token: '',
        baseUrl: '',
        payTypeList: [{text: '预付费', value: 0}, {text: '后付费', value: 1}],
        // surType: '',
        // surApplicationDate: '',
        list1: [{text: '待租中', value: 0}, {text: '配置中', value: 3}],
        list2: [{text: '身份证', value: 0}, {text: '港澳通行证', value: 1}],
        list3: [{text: '新', value: 0}, {text: '旧', value: 1}],
        list4: [{text: '正常', value: 0}, {text: '损坏', value: 1}],
        formRules2: {
          goodsPayAmount: [
            {required: true, message: '', trigger: 'blur', validator: this.validateNumber2}
          ]
        },
        formRules3: {
          goodsNewOld: [
            {required: true, message: '', trigger: 'change', validator: this.validateNumber}
          ],
          unit: [
            {required: true, message: '', trigger: 'blur', validator: this.validateNumber2}
          ],
          goodsStatus: [
            {required: true, message: '', trigger: 'change', validator: this.validateNumber}
          ],
          goodsPayAmount: [
            {required: true, message: '', trigger: 'blur', validator: this.validateNumber2}
          ]
        },
        formRules1: {
          meterPayType: [
            {required: true, message: '', trigger: 'change', validator: this.validateNumber}
          ],
          curMeterDisplay: [
            {required: true, message: '', trigger: 'blur', validator: this.validateNumber2}
          ],
          preMeterDisplay:[
            {required: true, message: '', trigger: 'blur', validator: this.validateNumber2}

          ]
          // meterAmount:[
          //   {required: true, message: '', trigger: 'blur', validator: this.validateNumber2}
          // ]
        },
        formRules12: {
          meterPayType: [
            {required: true, message: '', trigger: 'change', validator: this.validateNumber}
          ],
          curMeterDisplay: [
            {required: true, message: '', trigger: 'blur', validator: this.validateNumber3}
          ],
          preMeterDisplay:[
            {required: true, message: '', trigger: 'blur', validator: this.validateNumber2}

          ]
          // meterAmount:[
          //   {required: true, message: '', trigger: 'blur', validator: this.validateNumber2}
          // ]
        },
        loading: true,
        isShow: false,
        data1: [],
        data1Copy: [],
        data2: [],
        data3: [],
        validContractNum: false,
      }
    },
    methods: {
      validateNumber3(rule, value, callback) {
        let pattern = /^(-?\d+)(\.\d+)?$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },
      getMeterAmount(item) {
        item.meterAmount = ''
        if (item.isSmartDevice === true) {
          if (!item.curMeterDisplay && item.curMeterDisplay !== 0) {
            return
          }
          let params = {
            contractFid: item.contractFid,
            meterType: item.meterType,
            curMeterDisplay: item.curMeterDisplay
          }
          calSurrenderMeterDeliveryAmount(params).then(res => {
            if (!res.data) {
              return
            }
            item.meterAmount = res.data.meterAmount
          }).catch(error => {
          })
        }
        else {
          if ((item.curMeterDisplay !== 0 && !item.curMeterDisplay) || (!item.preMeterDisplay && item.preMeterDisplay !== 0)) {
            return
          }
          if (item.meterPayType === 0) { //预付费

            item.meterAmount = ((Number(item.curMeterDisplay) - Number(item.preMeterDisplay)) * Number(item.unitPrice)).toFixed(2)
          }
          if (item.meterPayType === 1) {//后付费 本次示数不能小于上次示数
            if(Number(item.curMeterDisplay) < Number(item.preMeterDisplay)) {
              this.$Message.info('后付费：录入本次示数不能小于上次示数')
              return;
            }
            item.meterAmount = -((Number(item.curMeterDisplay) - Number(item.preMeterDisplay)) * Number(item.unitPrice)).toFixed(2)
          }
        }


      },
      showImg(src) {
        this.imgSrc = src
        this.imgN++
      },
      cleanData() {
        this.data1 = []
        this.data1Copy = []
        this.data2 = []
        this.data3 = []
        for (let i in this.$refs) {
          if (i === 'formData') {
            this.$refs[i].resetFields()
          }
          else {
            this.$refs[i][0] && this.$refs[i][0].resetFields()
          }
        }
      },
      formatDateTime: formatDateTime,
      closeModal() {
        this.isShow = false
      },
      validateNumber2(rule, value, callback) {
        let pattern = /^(\d+)(\.\d+)?$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },
      surrenderdeliverysave() {
        this.data2.forEach(ele => {
          ele['deliveryType'] = 0
        })
        this.data3.forEach(ele => {
          ele['deliveryType'] = 1
        })
        let goodList = this.data2.concat(this.data3)
        goodList.forEach(ele => {
          ele['surrenderFid'] = this.surrenderFid
          ele['contractFid'] = this.contractFid
          ele['stockFid'] = this.stockFid
        })
        this.data1Copy.forEach(ele => {
          ele['surrenderFid'] = this.surrenderFid
          ele['stockFid'] = this.stockFid
        })
        let params = {
          surMeterDeliveryParamDtoList: this.data1Copy,
          surGoodsDeliveryParamDtoList: goodList,
        }
        surrenderdeliverysave(params).then(res => {
          this.$emit('done')
          this.isShow = false
        }).catch(error => {
          this.changeLoading()

        })
      },
      validateNumber(rule, value, callback) {
        let pattern = /^\d+$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },
      validContract() {
        if (!this.changeContractCode) {
          return
        }
        let params = {
          contractCode: this.changeContractCode,
          contractFid: this.contractFid
        }
        validChangeRentContract(params).then(res => {
          this.validContractNum = true
        }).catch(error => {
          this.$Message.info('校验失败')
        })
      },
      handleSuccess(res, file) {
        let index = Number(res.data.type)
        this.data1Copy[index].meterPicName = file.name.length<=10?file.name:file.name.slice(0,10)+'...'
        this.data1Copy[index].meterPic = res.data.url
      },
      formatError() {
        this.$Message.info('请上传图片格式(jpg、png、jpeg)文件')
      },
      handleError() {

      },
      getSurrenderDecorationGoodsDeliveryInitInfo() {
        let params = {
          contractId: this.contractFid
        }
        getSurrenderDecorationGoodsDeliveryInitInfo(params).then(res => {
          res.data && res.data.forEach(ele => {
            ele['goodsNewOld'] = 1
            ele['unit'] = 0
            ele['goodsStatus'] = 0
            ele['goodsPayAmount'] = 0
          })
          this.data3 = res.data
        }).catch(error => {
        })

      },
      getSurrenderGoodsDeliveryInitInfo() {
        let params = {
          contractId: this.contractFid
        }
        getSurrenderGoodsDeliveryInitInfo(params).then(res => {
          res.data && res.data.forEach(ele => {
            ele['goodsPayAmount'] = 0
          })
          this.data2 = res.data
        }).catch(error => {
        })

      },
      getPersonalSurrenderMeterDeliveryInitInfo() {
        if (!this.contractFid) {
          return
        }
        let params = {
          contractId: this.contractFid
        }
        getPersonalSurrenderMeterDeliveryInitInfo(params).then(res => {
          res.data.forEach(ele => {
            ele['meterPicName'] = ''
          })
          this.data1 = res.data
          this.data1Copy = deepClone(this.data1)
        }).catch(error => {
        })
      },
      getPersonalSurrenderInitInfo() {
        if (!this.contractFid) {
          return
        }
        let params = {
          contractId: this.contractFid
        }
        getPersonalSurrenderInitInfo(params).then(res => {
          res.data['stockStatus'] = ""
          res.data['surReason'] = ''
          res.data['surReasonType'] = ''
          this.data = res.data
        }).catch(error => {
        })
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok() {
        //+表单校验
        let flag = true
        for (let i in this.$refs) {
          if (i == 'formData') {
            this.$refs[i].validate(bool => {
              !bool && (flag = false)
            })
          }
          else {
            this.$refs[i][0] && this.$refs[i][0].validate(bool => {
              !bool && (flag = false)
            })
          }
        }
        if (!flag) {
          this.$Message.info('请检查输入')
          this.changeLoading()
          return
        }

        //校验图片上传
        let fileValid = true
        for (let i = 0, len = this.data1.length; i < len; i++) {
          if (!this.data1[i].curMeterDisplay && this.data1[i].curMeterDisplay!==0) {
            if (!this.data1Copy[i].meterPic) {
              fileValid = false
              break
            }
          }
        }
        if (!fileValid) {
          this.$Message.info('请检查上传文件')
          this.changeLoading()
          return
        }
        this.surrenderdeliverysave()
      },
      cancel() {
      }
    },
    created() {
      this.baseUrl = getBaseUrl()
      this.token = getToken()
    }
  }
</script>

<style scoped>

  .mb15form .ivu-form-item {
    margin-bottom: 15px;
  }

  .width250 {
    width: 350px;
  }

  .width150 {
    width: 200px;
  }

  .mb26 {
    margin-bottom: 26px;
  }

  .left, .right {
    display: inline-block;
    line-height: 2.5;
  }

  .left {
    width: 100px;
  }

  h4 {
    /*margin-top: 25px;*/
    margin-bottom: 10px;
  }

  .row {
    text-align: center;
    /*margin-bottom: 10px;*/
    line-height: 32px;

    border-left: 1px solid rgb(222, 222, 222);
    border-right: 1px solid rgb(222, 222, 222);
    border-bottom: 1px solid rgb(222, 222, 222);
    padding: 7px;
    font-weight: bold;
  }

  .row:first-child {
    border-top: 1px solid rgb(222, 222, 222);
    background-color: rgb(248, 248, 248);
    padding: 5px;
  }

  .inputwidth {
    width: 80px;
  }

  .ivu-select-dropdown {
    top: 32px !important;
  }


</style>
